import { render, staticRenderFns } from "./loginAdmin.vue?vue&type=template&id=ac10605c&"
import script from "./loginAdmin.vue?vue&type=script&lang=js&"
export * from "./loginAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports